import React, { Component } from 'react';
import { Route, Switch } from 'react-router-dom';

import NoMatch from './NoMatch';
import Navbar from './Navbar/Navbar';
import Home from './Home/Home';
import Shipping from './Shipping/Shipping';
import Contact from './Contact/Contact';
import Forms from './Forms/Forms';
import Footer from './Footer/Footer';
import Rewards from './Rewards/Rewards';
import Satisfaction from './Satisfaction/Satisfaction';
import Price from './Price/Price';

class App extends Component {
  state = {};
  render() {
    return (
      <div className="app">
        <Navbar />
        <div className="content">
          <Switch>
            <Route exact path="/" component={Home} />
            <Route path="/shipping" component={Shipping} />
            <Route path="/forms" component={Forms} />
            <Route path="/contact" component={Contact} />
            <Route path="/rewards" component={Rewards} />
            <Route path="/satisfaction-guarantee" component={Satisfaction} />
            <Route path="/price-guarantee" component={Price} />
            <Route path="/*" component={NoMatch} />
          </Switch>
        </div>
        <Footer />
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/components/App.js